import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'



// 引入vant
import vant from 'vant';
//引入vant样式组件
import 'vant/lib/index.css';


const app = createApp(App)


axios.defaults.baseURL = 'http://192.168.0.3:8000/v1'
axios.interceptors.request.use(config => {
    // console.log(config);
    config.headers.Authorization = window.localStorage.getItem("token")
    // 在最后必须 return config
    return config
})

//将axios挂载到app这个实例上
app.config.globalProperties.$http = axios;

// 使用vant(全局引入)
app.use(vant).use(store).use(router).mount('#app')


